// src/components/restake/GainOpportunities.tsx

import React from "react";
import { Typography, Card } from "@kelp-dao/kernel-design-system";
import { CaretRightIcon } from "@phosphor-icons/react";
import { useVaultTvlApy } from "@hooks/useVaultTvlApy";
import { TGainOpportunity } from "./types";
import { getUrlForLocalImage, trackEvent } from "utils";
import UTMLink from "@components/UTMLink/UTMLink";
import { RESTAKE_SIDEBAR_GAIN } from "@constants/analytics";

const GainOpportunities: React.FC = () => {
  const { formattedApy = "-", formattedTvl = "-" } = useVaultTvlApy("agETH");
  const { formattedApy: yieldApy = "-", formattedTvl: yieldTvl = "-" } =
    useVaultTvlApy("hgETH");

  return (
    <div className={"mt-8"}>
      <div className="space-y-4">
        <Card
          variant="non-bordered"
          className="p-6 border border-border-subtle rounded-2xl bg-white flex flex-col gap-4"
        >
          <Typography
            type="body"
            variant="small"
            className="text-text-secondary font-semibold tracking-wider"
          >
            Gain opportunities
          </Typography>
          <GainOpportunityStats
            id="airdrop"
            title="Airdrop Gain"
            apy={formattedApy}
            tvl={formattedTvl}
            iconSrc="/assets/ageth.svg"
            link="/gain/airdrop-gain/"
            onClick={() => {}} // Event
          />
          <GainOpportunityStats
            id="yield"
            title="High Gain"
            apy={yieldApy}
            tvl={yieldTvl}
            iconSrc="/assets/vaults/hgeth.svg"
            link="/gain/growth-vault/"
            onClick={() => {}} // Event
          />
        </Card>
      </div>
    </div>
  );
};

const GainOpportunityStats: React.FC<TGainOpportunity> = ({
  title,
  apy,
  tvl,
  iconSrc,
  link,
  id,
}) => {
  return (
    <UTMLink
      href={link}
      key={id}
      onClick={() => trackEvent(RESTAKE_SIDEBAR_GAIN, { vault_name: title })} // Event
    >
      <div className="flex items-center justify-between cursor-pointer">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-full flex items-center justify-center">
            <img
              src={getUrlForLocalImage(iconSrc)}
              alt={title}
              className="w-7 h-7"
            />
          </div>
          <div>
            <Typography
              type="heading"
              variant="xxsmall"
              className="text-text-primary font-medium font-sans"
            >
              {title}
            </Typography>
            <div className="flex gap-4 mt-1">
              <span className="text-[12px] md:text-[14px] text-text-secondary">
                APR {apy}
              </span>
              <span className="text-[12px] md:text-[14px] text-text-secondary">
                TVL {tvl}
              </span>
            </div>
          </div>
        </div>
        <CaretRightIcon size={20} className="text-text-secondary" />
      </div>
    </UTMLink>
  );
};

export default GainOpportunities;
